import type { SourceSnapshot } from '@/model/sourceState/sourcestate.generated';

import { unwrapEnvelopeOr } from '@/model/client';
import {
  sourceStateApi,
  useGetApiProjectsByProjectIdSourceStatesAndSourceIdQuery,
} from '@/model/sourceState/api.generated';
import {
  isSourceSyncing,
  pollingIntervalFor,
} from '@/viewmodel/features/sourceState/mappers/polling';
import { skipToken } from '@reduxjs/toolkit/query/react';

export function useSourceSnapshot(
  projectId: string | undefined,
  sourceId: string,
  liveUpdates: boolean,
  awaitingRun = false,
): { source: SourceSnapshot | undefined } {
  const arg = projectId ? { projectId, sourceId } : skipToken;
  const { data: cached } =
    sourceStateApi.endpoints.getApiProjectsByProjectIdSourceStatesAndSourceId.useQueryState(arg);
  const cachedSource = unwrapEnvelopeOr<SourceSnapshot | undefined>(cached, undefined);
  const pollingInterval = pollingIntervalFor(
    liveUpdates,
    cachedSource !== undefined && isSourceSyncing(cachedSource),
    awaitingRun,
  );
  const query = useGetApiProjectsByProjectIdSourceStatesAndSourceIdQuery(arg, {
    pollingInterval,
    skipPollingIfUnfocused: true,
  });

  return { source: unwrapEnvelopeOr<SourceSnapshot | undefined>(query.data, undefined) };
}
